<template>
  <znl-dialog
    :visible="visible"
    @close="() =>{ $emit('update:visible', false); height = 335}"
    :append-to-body="true"
    width="340px"
    class="c-InquiryIframe"
    :is-footer-show="false"
    v-loading="loading"
    element-loading-text="加载中.."
  >
    <div
      class="iconbox"
      @click="$emit('update:visible', false)"
    >
      <i class="iconfont icon-close"></i>
    </div>
    <iframe
      :src="src"
      width="100%"
      :height="`${height}px`"
      :frameborder="0"
      name="Trading"
      ref="Trading"
      @load="loadHandler"
    >
      您的浏览器版本太低，请升级浏览器
    </iframe>
    <!-- <znl-button @click="clickHandler">切换</znl-button> -->
  </znl-dialog>
</template>
<script>
import { on, off } from '../assets/scripts/dom';
import TradingStore from '../store';
const __DEV__ = process.env.NODE_ENV !== 'production';
const HOSTNAME = location.hostname;
let IframeSrc = 'https://www.bom.ai/Trading/#/Upload';
// if (/^[local]/.test(HOSTNAME)) {
//   IframeSrc = 'http://192.168.1.10:8023/#/Upload';
// }
// if (/^(192\.168\.1\.10)/.test(HOSTNAME)) {
//   IframeSrc = 'http://192.168.1.10:8023/#/Upload';
// }
// if (/^[test]/.test(HOSTNAME)) {
//   IframeSrc = 'http://test.bom.ai/Trading/#/Upload';
// }
if (__DEV__) {
  IframeSrc = 'http://192.168.1.10:8023/#/Upload';
}
export default {
  name: 'InquiryIframe',
  props: {
    visible: Boolean,
    getDatas: Function
  },
  data() {
    return {
      src: IframeSrc,
      height: 335,
      loading: false,
      TradingStore
    };
  },
  watch: {
    visible(value) {
      if (value) {
        this.loading = true;
      } else {
        this.loading = false;
      }
    }
  },
  methods: {
    loadHandler(event) {
      this.loading = false;
      this.$refs.Trading.contentWindow.postMessage(
        JSON.stringify({
          token: this.TradingStore.state.token
        }),
        '*'
      );
    },

    readyHandler(e) {
      try {
        const DATA = JSON.parse(event.data);
        if (DATA.size) {
          this.height = DATA.size.height;
        }
        if (DATA.inquiryResults) {
          if (this.getDatas) {
            this.getDatas();
          }
          this.$emit('update:visible', false);
        }
      } catch (error) {
        // console.log(error.message);
      }
    }
  },
  mounted() {
    on(window, 'message', this.readyHandler);
  },
  beforeDestroy() {
    off(window, 'message', this.readyHandler);
  }
};
</script>
<style lang="scss">
.c-InquiryIframe {
  // position: relative;
  .znl-dialog__body {
    padding: 0;
  }
  .iconbox {
    position: absolute;
    top: -15px;
    right: -14px;
    width: 30px;
    height: 30px;
    border: 3px solid #fff;
    border-radius: 50%;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    background-color: #777777;
    &:hover {
      background-color: #ee7700;
    }
    .iconfont {
      font-size: 16px;
      font-weight: bold;
      color: #fff;
    }
  }
}
</style>


